import React from 'react';
import { format } from 'date-fns';
import { Calendar } from 'lucide-react';
import { useJobTimeline } from '../../hooks/useJobTimeline';

interface JobTimelineProps {
  jobId: string;
}

export default function JobTimeline({ jobId }: JobTimelineProps) {
  const { events, loading, error } = useJobTimeline(jobId);

  if (loading) {
    return <div className="text-gray-400">Loading timeline...</div>;
  }

  if (error) {
    return <div className="text-red-500">{error}</div>;
  }

  if (events.length === 0) {
    return (
      <div className="text-center py-8 text-gray-400">
        No timeline events yet
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {events.map((event, index) => (
        <div key={index} className="relative pl-10">
          <div className="absolute left-0 flex h-8 w-8 items-center justify-center rounded-full bg-dark-700 text-gray-400">
            <Calendar className="h-4 w-4" />
          </div>
          
          <div className="card p-4">
            <time className="text-sm font-medium text-gray-400 mb-2 block">
              {format(new Date(event.date), 'MMMM d, yyyy')}
            </time>
            <p className="text-gray-300">{event.description}</p>
          </div>
        </div>
      ))}
    </div>
  );
}